<template>
  <div class="scenicDetail" v-if="scenicData.scenicName">
    <!-- 轮播图 -->
    <van-swipe @change="onChange">
      <van-swipe-item v-for="item in swiperData" v-bind:key="item">
        <div
          class="swiper-pic"
          :style="{ 'background-image': 'url(' + picUrl + item + ')' }"
        ></div>
      </van-swipe-item>
      <template #indicator>
        <div class="custom-indicator">
          {{ current + 1 }}/{{ swiperData.length }}
        </div>
      </template>
    </van-swipe>
    <!-- 具体数据 -->
    <div class="scenic-wrap">
      <div class="section-first">
        <!-- 名称等级 -->
        <div class="name-leave">
          <span class="name van-ellipsis">{{ scenicData.scenicName }}</span>
          <img
            class="leave"
            :src="picUrl + 'qunaer/scenic/level01.png'"
            alt
            v-if="scenicData.scenicType == '3A景区'"
          />
          <img
            class="leave"
            :src="picUrl + 'qunaer/scenic/level02.png'"
            alt
            v-if="scenicData.scenicType == '4A景区'"
          />
          <img
            class="leave"
            :src="picUrl + 'qunaer/scenic/level03.png'"
            alt
            v-if="scenicData.scenicType == '5A景区'"
          />
          <img
            class="leave"
            :src="picUrl + 'qunaer/scenic/level04.png'"
            alt
            v-if="scenicData.scenicType == '主题乐园'"
          />
        </div>
        <!-- 标签 -->
        <ul class="tags">
          <li class="tag" v-for="item in scenicLabel" v-bind:key="item">
            {{ item }}
          </li>
        </ul>
        <!-- 营业时间 -->
        <div class="opentime">
          <span class="iconfont icontime2 icon"></span>
          <span v-if="scenicData.yearStartTime && scenicData.yearEndTime"
            >全年：{{ scenicData.yearStartTime }} -
            {{ scenicData.yearEndTime }}</span
          >
          <span
            v-if="
              scenicData.yearStartTime &&
                scenicData.yearEndTime &&
                scenicData.nightStartTime &&
                scenicData.nightEndTime
            "
            >;</span
          >
          <span v-if="scenicData.nightStartTime && scenicData.nightEndTime"
            >夜场：{{ scenicData.nightStartTime }} -
            {{ scenicData.nightEndTime }}</span
          >
          <span></span>
        </div>

        <!-- 位置距离导航 -->
        <div class="address-distance-gps">
          <span class="address-distance van-ellipsis">
            <span class="address van-ellipsis" v-if="scenicData.address">
              <span class="iconfont iconsite icon"></span>
              {{ scenicData.address }}
            </span>
            <span
              class="line"
              v-if="scenicData.address && scenicData.distance"
            ></span>
            <span class="distance" v-if="scenicData.distance">{{
              distance
            }}</span>
          </span>

          <span class="gps" @click="gpsGo">
            导航
            <span class="iconfont iconxiangqingye_daohang icon"></span>
          </span>
        </div>
      </div>

      <div class="section-sceond">
        <van-tabs v-model="activeName" swipeable color="#00BC7A">
          <van-tab title="景区简介" name="a">
            <template v-if="scenicData.introduction">
              <div class="label">景区简介</div>
              <div class="text" v-html="introduction"></div>
            </template>
            <template v-if="scenicData.scenicInstructions">
              <div class="label">景区说明</div>
              <div class="text" v-html="scenicInstructions"></div>
            </template>
          </van-tab>
          <van-tab title="交通出行" name="b">
            <template v-if="scenicData.transportation">
              <div class="label">交通出行</div>
              <div class="text" v-html="transportation"></div>
            </template>
            <template v-if="scenicData.bestQuarter">
              <div class="label">最佳季节</div>
              <div class="text" v-html="bestQuarter"></div>
            </template>
          </van-tab>
          <van-tab title="注意事项" name="c">
            <template v-if="scenicData.attention">
              <div class="label">注意事项</div>
              <div class="text" v-html="attention"></div>
            </template>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <!-- 底部预约栏 -->
    <div class="footer">
      <div class="makePhone">
        <span
          class="iconfont iconxingzhuangjiehe icon"
          @click="homeBace"
        ></span>
        <span class="text">返回首页</span>
      </div>
      <a class="makePhone" :href="'tel:' + scenicPhone">
        <span class="iconfont iconkefurexian icon"></span>
        <span class="text">客服热线</span>
      </a>
      <div class="button" @click="showPopup">立即预约</div>
      <van-popup style="width: 100%" position="bottom" v-model="show">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="orderClick"
          @cancel="closePopup"
        />
      </van-popup>
    </div>
  </div>
</template>
<script>
import {
  Swipe,
  SwipeItem,
  Tab,
  Tabs,
  Popup,
  DatetimePicker,
  Toast,
  Dialog,
} from "vant"

import Cookies from "js-cookie"
import { getLocation } from "../utils/mapApi.js"
import { setToken, getPicUrl } from '../utils/auth'
import { getUserInfo, getScenicInfo, userAppointment1 } from '../api/index'

export default {
  name: "ScenicDatail",
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      picUrl: getPicUrl(),
      scenicId: "",
      latitude: "",
      longitude: "",
      activeName: "a",
      userId: "",
      current: 0,
      scenicData: {},
      show: false,
      currentDate: new Date(),
      appointmentTime: "",
      distance: "",
      qunaerUser: {},
    };
  },
  created() {
    const that = this
    this.businessId = this.$route.params.businessId
    this.scenicId = this.$route.params.scenicId
    this.getUserInfo()
      .then((res) => {
        setToken(res.data.data.token)
        const qunaerUser = res.data.data.qunaerUser;
        if (!qunaerUser.arriveTime || !qunaerUser.validityTime) {
          that.$toast("信息错误")
          return
        }
        that.qunaerUser = qunaerUser
        const latitude = Cookies.get("latitude")
        const longitude = Cookies.get("longitude")
        if (!latitude || !longitude) {
          getLocation()
            .then((res) => {
              that.latitude = res.position.lat
              that.longitude = res.position.lng
              that.getScenicInfo()
            })
            .catch((err) => {
              console.log(err)
              that.getScenicInfo()
            })
        } else {
          that.latitude = latitude
          that.longitude = longitude
          that.getScenicInfo()
        }
      })
      .catch((err) => {
        that.$toast(err)
      })
  },
  computed: {
    //轮播图
    swiperData() {
      return this.scenicData && this.scenicData.carouselUrl
        ? JSON.parse(this.scenicData.carouselUrl)
        : [];
    },
    // 标签
    scenicLabel() {
      const scenicLabel =
        this.scenicData.scenicLabel && this.scenicData.scenicLabel.length
          ? this.scenicData.scenicLabel.split(",")
          : [];
      return scenicLabel.filter((item) => {
        return item.length > 0;
      });
    },
    // 电话
    scenicPhone() {
      return this.scenicData && this.scenicData.scenicPhone
        ? this.scenicData.scenicPhone
        : "4006086166";
    },
    // 日期插件日期限制
    minDate() {
      let dateStart = "";
      // 落地时间
      let arriveTime = new Date(this.qunaerUser.arriveTime.replace(/\-/g, "/"));
      arriveTime = arriveTime.getTime();
      // 结束时间
      let validityTime = new Date(
        this.qunaerUser.validityTime.replace(/\-/g, "/")
      );
      validityTime = new Date(validityTime.getTime());
      // console.log(this.qunaerUser.arriveTime,this.qunaerUser.validityTime)
      // 默认预约时间计算
      const nowDate = new Date();
      let nowTime =
        nowDate.getFullYear() +
        "/" +
        (nowDate.getMonth() + 1) +
        "/" +
        nowDate.getDate() +
        " 00:00:00";
      nowTime = new Date(nowTime).getTime() + 2 * 24 * 60 * 60 * 1000;

      // 默认预约时间小于等于落地时间，为落地时间
      if (nowTime <= arriveTime) {
        dateStart = new Date(arriveTime);
      }
      // 默认预约时间大于落地时间，为默认预约时间
      if (nowTime > arriveTime) {
        dateStart = new Date(nowTime);
      }
      // 默认时间超出结束时间，为空，不允许预约
      if (nowTime > validityTime) {
        dateStart = "";
      }

      dateStart =
        dateStart === ""
          ? ""
          : new Date(
              dateStart.getFullYear(),
              dateStart.getMonth(),
              dateStart.getDate()
            );
      return dateStart;
    },
    // 日期插件日期限制
    maxDate() {
      let dateEnd = "";
      // 结束时间
      let validityTime = new Date(
        this.qunaerUser.validityTime.replace(/\-/g, "/")
      );
      validityTime = validityTime.getTime();

      // 默认预约时间计算
      const nowDate = new Date();
      let nowTime =
        nowDate.getFullYear() +
        "/" +
        (nowDate.getMonth() + 1) +
        "/" +
        nowDate.getDate() +
        " 00:00:00";
      nowTime = new Date(nowTime).getTime() + 2 * 24 * 60 * 60 * 1000;

      // 可预约时间小于登月结束时间，取结束时间
      if (nowTime <= validityTime) {
        dateEnd = new Date(validityTime);
      }
      // 可预约时间大于结束时间，取结束时间
      if (nowTime > validityTime) {
        dateEnd = "";
      }
      dateEnd =
        dateEnd === ""
          ? ""
          : new Date(
              dateEnd.getFullYear(),
              dateEnd.getMonth(),
              dateEnd.getDate()
            );
      return dateEnd;
    },
    // 景区简介
    introduction() {
      return this.scenicData && this.scenicData.introduction
        ? this.scenicData.introduction.replace(/href/g, "")
        : "";
    },
    // 景区说明
    scenicInstructions() {
      return this.scenicData && this.scenicData.scenicInstructions
        ? this.scenicData.scenicInstructions.replace(/href/g, "")
        : "";
    },
    // 交通出行
    transportation() {
      return this.scenicData && this.scenicData.transportation
        ? this.scenicData.transportation.replace(/href/g, "")
        : "";
    },
    // 最佳季节
    bestQuarter() {
      return this.scenicData && this.scenicData.bestQuarter
        ? this.scenicData.bestQuarter.replace(/href/g, "")
        : "";
    },
    // 注意事项
    attention() {
      return this.scenicData && this.scenicData.attention
        ? this.scenicData.attention.replace(/href/g, "")
        : "";
    },
  },
  watch: {
    scenicData() {
      let m = "";
      const distance = this.scenicData.distance;
      if (distance / 1000 >= 1) {
        m = (distance / 1000).toFixed(2) + "km";
      } else {
        m = distance + "m";
      }
      this.distance = m;
    },
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      const businessId = this.businessId
      return getUserInfo({ businessId })
    },
    // 轮播图切换
    onChange(index) {
      this.current = index
    },
    // 获取景区详情
    getScenicInfo() {
      const that = this
      this.$toast({
        type: "loading",
        mask: true,
        duration: 0,
        message: "加载中..."
      })
      const { latitude, longitude, scenicId } = this
      const productType = process.env.VUE_APP_PRODUCT_TYPE
      getScenicInfo({ latitude, longitude, scenicId, productType })
        .then((res) => {
          if (res.data.code != "200") {
            throw res.data.msg
          }
          if (res.data.code == "200") {
            that.$toast.clear()
            that.scenicData = res.data.data
          }
        })
        .catch((err) => {
          that.$toast.clear()
          that.$toast(err)
        })
    },
    // 点击预约日期插件弹起
    showPopup() {
      if (this.minDate === "" || this.maxDate === "") {
        this.$toast("景区需提前两天预约，暂无法预约")
        return
      }
      this.show = true
    },
    // 点击预约日期插件关闭
    closePopup() {
      this.show = false
    },
    // 预约日期转换
    dateTrans(value) {
      const date = new Date(value)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + "-" + month + "-" + day + " 23:59:59"
    },
    // 预约条件筛选
    orderClick(value) {
      this.closePopup()
      this.appointmentTime = this.dateTrans(value)
      this.userAppointment()
    },
    // 预约请求
    userAppointment() {
      const that = this
      this.$toast({
        type: "loading",
        mask: true,
        duration: 0,
        message: "预约请求中..."
      })
      const { businessId, scenicId, appointmentTime } = this
      userAppointment1({ businessId, scenicId, appointmentTime }).then(res => {
        that.$toast.clear()
        if (res.data.code !== 200 && res.data.code !== 409) {
          throw res.data.msg
        }
        // 未完善信息
        if (res.data.code === 409) {
          that.$router.push({
            name: "OrderFrom",
            params: { businessId: this.businessId }
          })
          return
        }
        if (res.data.code === 200) {
          that.$dialog
            .confirm({
              message: "预约成功，是否跳转到预约？"
            })
            .then(() => {
              that.$router.push({
                name: "Order",
                params: { businessId: businessId }
              })
            })
        }
      })
      .catch(error => {
        that.$toast.clear()
        that.$toast(error)
      })
    },
    // 返回首页
    homeBace() {
      this.$router.back()
    },
    // 导航
    gpsGo() {
      const { latitude, longitude, scenicName, address } = this.scenicData;
      window.location.href = `http://apis.map.qq.com/uri/v1/marker?marker=coord:${latitude},${longitude};title:${scenicName};addr:${address}`;
    }
  }
}
</script>

<style scoped>
/* 轮播图 */
.swiper-pic {
  width: 100%;
  height: 400px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.custom-indicator {
  position: absolute;
  right: 5px;
  bottom: 35px;
  border-radius: 20px;
  width: 100px;
  height: 40px;
  font-size: 12px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  background: rgba(0, 0, 0, 0.3);
}

/* 具体数据 */
.scenic-wrap {
  position: relative;
  z-index: 99;
  margin-top: -30px;
  border-radius: 30px 30px 0px 0px;
  width: 100%;
  overflow-y: auto;
  background: #fafafa;
}
.section-first {
  padding: 35px 30px 0 30px;
  width: calc(100% - 60px);
  background: #fff;
}
/* 名称等级 */
.scenic-wrap .name-leave {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 56px;
  font-size: 40px;
  font-weight: bold;
}
.scenic-wrap .name {
  display: inline-block;
  width: calc(100% - 125px);
}
.scenic-wrap .leave {
  width: 120px;
  height: 40px;
}
/* 标签 */
.tags {
  display: flex;
  flex-wrap: wrap;
  margin-top: 18px;
}
.tags .tag {
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 0 16px;
  height: 40px;
  font-size: 24px;
  font-weight: bold;
  line-height: 40px;
  color: #00b978;
  background: #e7fcf4;
}
.tags .tag:nth-of-type(2n) {
  color: #f35454;
  background: #ffecec;
}
/* 营业时间 */
.opentime {
  position: relative;
  margin-top: 30px;
  height: 100px;
  font-size: 28px;
  line-height: 100px;
}
.opentime::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0px;
  width: calc(100% + 30px);
  height: 1px;
  background: #eee;
}
.opentime .icon {
  margin-right: 10px;
  font-size: 26px;
  color: #e0e0e0;
}
/* 地址距离导航 */
.address-distance-gps {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
  font-size: 28px;
}
.address-distance-gps .address-distance {
  flex: 0 1 auto;
  display: flex;
  align-items: center;
  height: 40px;
}
.address-distance-gps .address-distance .line {
  margin: 0 30px;
  height: 100%;
  width: 2px;
  background: #e0e0e0;
}
.address-distance-gps .address {
  flex: 0 1 auto;
}
.address-distance-gps .address .icon {
  margin-right: 10px;
  font-size: 26px;
  color: #e0e0e0;
}
.address-distance-gps .gps {
  margin-left: 15px;
  flex: 0 0 auto;
  font-size: 26px;
  color: #3a93f5;
}
.address-distance-gps .gps .icon {
  margin-left: 10px;
  font-size: 22px;
}
.section-sceond {
  margin-top: 30px;
  padding: 0px 30px 120px 30px;
  width: calc(100% - 60px);
  background: #fff;
  overflow: hidden;
}
.section-sceond .label {
  padding: 38px 0 19px 0;
  font-size: 32px;
  font-weight: bold;
}
.section-sceond .text {
  font-size: 24px;
  line-height: 45px;
  color: #666;
}
.section-sceond .text >>> a {
  color: #666;
}
.section-sceond .text >>> img {
  width: 100% !important;
}
/* 底部预约 */
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 100;
  box-shadow: 0px -2px 20px 0px rgba(201, 201, 201, 0.5);
  padding: 0 30px;
  width: calc(100% - 60px);
  height: 120px;
  background: #fff;
}
.footer .makePhone {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 22px;
  color: #333 !important;
}
.footer .makePhone .icon {
  font-size: 48px;
  color: #00bc7a;
}
.footer .button {
  box-shadow: 0px 4px 8px 0px rgba(22, 194, 124, 0.24);
  border-radius: 10px;
  width: 370px;
  height: 88px;
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  line-height: 88px;
  color: #fff;
  background: linear-gradient(
    135deg,
    rgba(82, 211, 131, 1) 0%,
    rgba(0, 188, 122, 1) 100%
  );
}
</style>